import { useTranslation } from "react-i18next";
import { Page } from "@/components/Page";
import { LearningSection } from "./LearningSection";
import { MemorySection } from "./MemorySection";

/** What AnthmAI learns from the user's chats and what their agents remember (each part capability-gated). */
export function MemoryPage() {
  const { t } = useTranslation("settings");
  return (
    <Page title={t("memoryPage.title")} subtitle={t("memoryPage.subtitle")}>
      <LearningSection />
      <MemorySection />
    </Page>
  );
}
